import {Injectable, EventEmitter} from '@angular/core';
import {Subscription, take, timer} from 'rxjs';
import jwtDecode from 'jwt-decode';
import {StorageKeysEnum} from "../../storage/storage-keys.enum";

type Token = {
  iss: string,
  exp: number,
  sub: string,
  aud: string
}

@Injectable({
  providedIn: 'root'
})
export class TokenExpiredTimerService {

  private logoutTimer!: Subscription | null//360000
  private logoutTimeMs: number = 300000
  private _enableTimer: boolean = true;
  // public start: () => void
  public logoutTimerExpired: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }


  startLogoutTimer() {
    const sessionToken: string | null = sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN);
    const wso = sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO)
    if(sessionToken && wso && this.enableTimer) {
      this.clearLogoutTimer();
      this.logoutTimer = timer(this.logoutTimeMs)
      .pipe(take(1))
      .subscribe(() => {
        this.enableTimer = false;
        this.logoutTimerExpired.emit()
      });
    }
  }

  resetLogoutTimer() {
    if(this.enableTimer) {
      this.clearLogoutTimer();
      this.startLogoutTimer();
    }
  }


  clearLogoutTimer() {
    if (this.logoutTimer) {
      this.logoutTimer.unsubscribe();
      this.logoutTimer = null;
    }
  }

  public get enableTimer(): boolean {
    return this._enableTimer
  }

  public set enableTimer(enableTimer: boolean) {
    this._enableTimer = enableTimer;
  }
}
